import classNames from 'classnames';
import * as React from 'react';

// A type alias would defeat react/prop-types resolution, so an empty interface it is
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {}

export const Container: React.FunctionComponent<ContainerProps> = ({className, children, ...rest}: ContainerProps) => (
    <div className={classNames('mp-container', className)} {...rest}>
        {children}
    </div>
);
